export default __webpack_public_path__ + "fa3d7c0a659fa11c05c258bfdae8f1fd.svg";